import { BaseFetch } from "../main-model"
export default class YearClassModel extends BaseFetch {
  getYearClassBy = (data) =>
    this.authFetch({
      url: "year-class/getYearClassBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getYearClassById = (data) =>
    this.authFetch({
        url: "year-class/getYearClassById",
        method: "POST",
      body: JSON.stringify(data),
    })
    updateYearClassById = (data) =>
    this.authFetch({
      url: "year-class/updateYearClassById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertYearClass = (data) =>
    this.authFetch({
      url: "year-class/insertYearClass",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteYearClassById = (data) =>
    this.authFetch({
      url: "year-class/deleteYearClassById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
